<template>
  <div data-component-group="panels" data-component="network-status-select">
    <v-menu
      v-model="isMenuOpen"
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ props }">
        <!--v-on="on"-->
        <!--v-bind="attrs"-->
        <span
          v-bind="props"
          class="menu-text"
        >
          <span
            data-cy="menu-text-item"
            :class="getStatusStyle(item.status.name)"
          >
            {{ item.status.name }}
          </span>
          <v-icon class="menu-icon"> keyboard_arrow_down </v-icon>
        </span>
      </template>

      <v-list class="menu-wrapper">
        <v-list-item
          v-for="status in availableStatuses"
          class="menu-item"
          :key="status.name"
          @click="onStatusSelect(item, status)"
        >
          <v-list-item-title :class="getMenuItemTitleStyle(item, status)">
            <span :class="status.class" />
            {{ status.name }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
  export default {
    props: {
      item: {
        type: Object,
        required: true,
      },
      getNetworks: {
        type: Function,
        default: () => {},
      },
    },
    data() {
      return {
        isLoading: false,
        isMenuOpen: false,
      };
    },
    computed: {
      statuses() {
        return this.$store.getters['networks/statuses'];
      },
      availableStatuses() {
        const { item, statuses } = this;
        const filteredStatuses = statuses.filter((s) => s.name !== 'Pending');

        return item.status.name === 'Pending' ? statuses : filteredStatuses;
      },
      canChangeNetworkStatus() {
        return this.$ability.can('change-status', 'network');
      },
    },
    methods: {
      onStatusSelect(item, status) {
        this.isMenuOpen = false;
        if (
          !this.$ability.can('change-status', 'network') ||
          this.isLoading ||
          !item ||
          !status ||
          status.name === item.status.name
        ) {
          return;
        }

        const query = {
          status,
          network: item,
          country: item.country.code,
        };

        this.isLoading = true;

        return this.$store
          .dispatch('networks/updateItemStatus', query)
          .then((res) => {
            this.getNetworks();
            this.isLoading = false;

            return res;
          })
          .catch((err) => {
            this.isLoading = false;
            return err;
          });
      },
      getStatusStyle(item) {
        return item.toLowerCase();
      },
      getMenuItemTitleStyle(item, status) {
        return item.status.id === status.id
          ? 'menu-item-title-active'
          : 'menu-item-title';
      },
    },
  };
</script>

<style lang="scss">
[data-component-group='panels'][data-component='network-status-select'] {
  .menu-text {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    font-weight: 500;

    .pending {
      color: #f57c00;
    }

    .approved {
      color: #212121;

      .v-theme--dark & {
        color: rgb(var(--v-theme-on-surface));
      }
    }

    .denied {
      color: #e53935;
    }

    .menu-icon {
      color: #212121;

      .v-theme--dark & {
        color: rgb(var(--v-theme-on-surface));
      }
    }
  }
}

.menu-wrapper {
  padding: 0;

  .menu-item {
    padding-inline: 0 !important;
    padding: 0;
    min-height: 0;
    cursor: pointer;

    .menu-item-title {
      padding: 12px 24px 12px 8px;
      font-size: 14px;
      color: #424242;
      background-color: rgb(var(--v-theme-surface));

      .v-theme--dark & {
        color: rgb(var(--v-theme-on-surface));
      }
    }

    .menu-item-title-active {
      padding: 12px 24px 12px 8px;
      font-size: 14px;
      color: #fb8c00;
      background-color: #fff1e6;
    }
  }
}
</style>
